import LoginTiac from "./login";

export default LoginTiac;